export default {
  // any array should have unique values as the values are used as keys
  // months
  formattedShortMonths: [
    'Sty',
    'Lut',
    'Mar',
    'Kwi',
    'Maj',
    'Cze',
    'Lip',
    'Sie',
    'Wrz',
    'Paź',
    'Lis',
    'Gru',
  ],
  months: [
    'Styczeń',
    'Luty',
    'Marzec',
    'Kwiecień',
    'Maj',
    'Czerwiec',
    'Lipiec',
    'Sierpień',
    'Wrzesień',
    'Październik',
    'Listopad',
    'Grudzień',
  ],
  months_calendar: {
    January: 'Styczeń',
    February: 'Luty',
    March: 'Marzec',
    April: 'Kwiecień',
    May: 'Maj',
    June: 'Czerwiec',
    July: 'Lipiec',
    August: 'Sierpień',
    September: 'Wrzesień',
    October: 'Październik',
    November: 'Listopad',
    December: 'Grudzień',
  },
  // weekdays
  weekdays: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
  weekdays_booking_container: {
    Sunday: 'Niedziela',
    Monday: 'Poniedziałek',
    Tuesday: 'Wtorek',
    Wednesday: 'Środa',
    Thursday: 'Czwartek',
    Friday: 'Piątek',
    Saturday: 'Sobota',
  },
  weekdays_calendar: {
    Sun: 'Nd',
    Mon: 'Pn',
    Tue: 'Wt',
    Wed: 'Śr',
    Thu: 'Cz',
    Fri: 'Pt',
    Sat: 'So',
  },
  // additional translations
  today: 'Dziś',
  tomorrow: 'Jutro',
};
